import Page from '@components/Page/Page'
import ParticipationStatus from '@components/participationStatus/ParticipationStatus'
import { BooleanTag } from '@components/utils/BooleanTag'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { ParticipationStatus as ParticipationStatusModel } from '@models/Event'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getParticipationStatuses,
  selectParticipationStatuses,
  setParticipationStatusQuery,
} from '@store/membership/ParticipationStatusReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { useEffect } from 'react'

const ParticipationStatusesPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const participationStatuses = useAppSelector(selectParticipationStatuses())
  const { query, isLoading } = useAppSelector(
    (state) => state.participationStatus
  )

  const columns: TableColumnsType<ParticipationStatusModel> = [
    {
      title: 'Avatar',
      render: (record: ParticipationStatusModel) => (
        <ParticipationStatus.Tag id={record.id} />
      ),
    },
    {
      title: 'Default',
      render: (record: ParticipationStatusModel) => (
        <BooleanTag value={record.isDefault} />
      ),
    },
    {
      align: 'right',
      render: (record: ParticipationStatusModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update, SBRMAction.Delete]}
          entity={Entity.eventParticipationStatus}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchParticipationStatuses = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setParticipationStatusQuery(newQuery))
    dispatch(getParticipationStatuses(newQuery))
  }

  const { handleTableChange, params } =
    useTableUrlSync<ParticipationStatusModel>({
      onParamsChange: fetchParticipationStatuses,
    })

  useEffect(() => {
    if (isOpen) return

    fetchParticipationStatuses(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.manageSettingsMembershipSettings}
      pageTitle={{
        title: 'Participation statuses',
        level: 4,
        toolbar: (
          <SBRM.Actions
            actions={[SBRMAction.Create]}
            entity={Entity.eventParticipationStatus}
          />
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={participationStatuses}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default ParticipationStatusesPage
